module.exports = __webpack_public_path__ + "img/youngAndBeautiful.7ec37b03.jpeg";